import { View } from "@react-pdf/renderer";
import { color } from "../styles";

type SectionHeaderProps = View["props"];

const SectionHeader: React.FC<SectionHeaderProps> = (props) => {
  const { children, style, ...restProps } = props;

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 16,
        fontWeight: "bold",
        color: color.primary,
        marginBottom: 5,
        ...style,
      }}
      {...restProps}
    >
      {children}
    </View>
  );
};

export default SectionHeader;
